interface EnvConfig {
  apiBaseUrl: string;
  wsUrl: string;
  environment: 'development' | 'qa' | 'staging' | 'production';
  debug: boolean;
  demoMode: boolean;
  sentryDsn: string | null;
  sentryEnvironment: string;
  appVersion: string;
}

function validateEnv(): EnvConfig {
  const demoMode = import.meta.env.VITE_DEMO_MODE === 'true';
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim() || (demoMode ? 'http://localhost:3000' : '');
  const wsUrl = import.meta.env.VITE_WS_URL?.trim() || (demoMode ? 'http://localhost:3000' : '');
  const environment = import.meta.env.VITE_ENVIRONMENT || 'development';
  const debug = import.meta.env.VITE_DEBUG === 'true';
  const sentryDsn = import.meta.env.VITE_SENTRY_DSN?.trim() || null;
  const sentryEnvironment = import.meta.env.VITE_SENTRY_ENVIRONMENT || environment;

  const appVersion = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';

  // Validate required variables (skip in demo mode)
  if (!demoMode && !apiBaseUrl) {
    throw new Error(
      'Environment validation failed: VITE_API_BASE_URL is required but not set. ' +
      'Please check your .env file or environment configuration.'
    );
  }

  if (!demoMode && !wsUrl) {
    throw new Error(
      'Environment validation failed: VITE_WS_URL is required but not set. ' +
      'Please check your .env file or environment configuration.'
    );
  }

  // Validate environment value
  const validEnvironments = ['development', 'qa', 'staging', 'production'];
  if (!validEnvironments.includes(environment)) {
    throw new Error(
      `Environment validation failed: VITE_ENVIRONMENT must be one of ${validEnvironments.join(', ')}. ` +
      `Received: "${environment}"`
    );
  }

  return {
    apiBaseUrl,
    wsUrl,
    environment: environment as EnvConfig['environment'],
    debug,
    demoMode,
    sentryDsn,
    sentryEnvironment,
    appVersion,
  };
}

export const env = validateEnv();
